"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDispatchToProps = exports.mapStateToProps = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var AgentProfileAction_1 = require("@/pages/agentProfile/actions/AgentProfileAction");
var ResultTableSortable_1 = require("@/pages/common/components/ResultTableSortable");
var SfilterTypeGroup_1 = require("@/pages/common/states/sfilter/sections/SfilterTypeGroup");
exports.mapStateToProps = function (state, ownProps) { return (__assign(__assign({}, ownProps), { symbol: state.layout.currencies.options.find(function (it) { return it.key === state.layout.currencies.currentCurrencyId; }).symbol, googleApi: state.layout.googleApi, lang: state.layout.language.languages.filter(function (it) { return it.id === state.layout.language.current; })[0].code1 })); };
exports.mapDispatchToProps = function (dispatch) { return ({
    onPropertyFavClick: function (item) { return dispatch(AgentProfileAction_1.default.onPropertyFavClick(item)); },
    onPropertyEnquireClick: function (item) { return dispatch(AgentProfileAction_1.default.onPropertyEnquireClick(item)); },
    onPropertyItemClick: function (item) { return dispatch(AgentProfileAction_1.default.onPropertyItemClick(item)); },
}); };
var agentProfileProperties = function (props) {
    var properties = props.type === SfilterTypeGroup_1.ListingPurposeType.Rent
        ? props.properties.filter(function (it) { return it.type !== SfilterTypeGroup_1.SfilterType.BUY; })
        : props.properties.filter(function (it) { return it.type !== SfilterTypeGroup_1.SfilterType.RENT; });
    return (React.createElement(ResultTableSortable_1.default, { t: props.t, properties: properties, type: props.type, limit: props.showAllProperties ? -1 : props.limit, googleApikey: props.googleApi, currencyCode: props.symbol, lang: props.lang, onFavClick: props.onPropertyFavClick, onEnquireClick: props.onPropertyEnquireClick, onItemClick: props.onPropertyItemClick }));
};
exports.default = react_redux_1.connect(exports.mapStateToProps, exports.mapDispatchToProps)(agentProfileProperties);
